import { z } from 'zod';

const mobileProductOrderSchema = z.object({
  active: z.boolean(),
  expirationDate: z.string().nullable(),
  name: z.string().min(1),
  numberOfLicenses: z.number(),
  productId: z.number().min(1),
  purchaseOrderNumber: z.string(),
});

const mobileProductOrdersSchema = z.array(mobileProductOrderSchema);

const webProductOrderSchema = z.object({
  name: z.string().min(1),
  productId: z.number().min(1),
});

const webProductOrdersSchema = z.array(webProductOrderSchema);

export const companyOrderSchema = z.object({
  createdOn: z.string().min(1),
  mobileProductOrders: mobileProductOrdersSchema,
  modifiedOn: z.string().min(1),
  orderStatus: z.number(),
  targetAccountName: z.string().min(1),
  webProductOrders: webProductOrdersSchema,
});

export const companyOrdersSchema = z.array(companyOrderSchema);

export type CompanyOrder = z.infer<typeof companyOrderSchema>;

export type CompanyOrders = z.infer<typeof companyOrdersSchema>;
